/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import getData from './getData.tsx';

export const csmCustomerContextTenantMigratedStatusResource: RouteResource<boolean> =
	createResource<boolean>({
		type: 'CSM_CUSTOMER_CONTEXT_TENANT_MIGRATED_STATUS',
		getKey: () => 'csm-customer-context-tenant-migrated-status',
		getData: async () => getData(),
		maxAge: 1000 * 60 * 60 * 24, // 1 day
		isBrowserOnly: true,
	});
